import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { makeT } from '../../../../group_leader/helpers/i18n'
import { to12hr, to24hr } from '../../../helpers/pairings'

// A button that turns into a text field; a half-typed entry leaves the time alone.

const t = makeT('group_leader.event_setup.pairings')

const TeeTimeCell = ({ teeTime, foursomeId, onSave }) => {
  const [ editing, setEditing ] = useState(false)
  const [ draft, setDraft ] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    if (editing && inputRef.current) { inputRef.current.focus() }
  }, [ editing ])

  const commit = () => {
    const valid24 = to24hr(draft.trim())
    if (valid24) { onSave(foursomeId, to12hr(valid24)) }
    setEditing(false)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      commit()
    }
    if (event.key === 'Escape') { setEditing(false) }
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        className="gl-event-setup-sh-time-input"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={handleKeyDown}
        placeholder={t('sheet.time_edit_placeholder')}
        aria-label={t('sheet.time_edit_aria')}
      />
    )
  }

  return (
    <button
      type="button"
      className="gl-event-setup-sh-time"
      onClick={() => { setDraft(teeTime || ''); setEditing(true) }}
      aria-label={t('sheet.time_aria', { time: teeTime || '-' })}
      >
      {teeTime || '-'}
    </button>
  )
}

TeeTimeCell.propTypes = {
  // 12-hour string from the API, or null when unset
  teeTime: PropTypes.string,
  foursomeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  onSave: PropTypes.func.isRequired,
}

export default TeeTimeCell
